import { MEDIA_SMALL, SPACING_1, SPACING_3 } from '@mnd-frontend/ui';
import styled from 'styled-components';

const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  max-width: 100%;

  @media (max-width: ${MEDIA_SMALL}px) {
    flex-direction: column;
  }
  > * {
    flex: 1;
    min-width: 0;
  }
  gap: ${SPACING_1} ${SPACING_3};
`;

export default FiltersWrapper;
